<template>
  <div class="userData">

    <div class="welcomeDiv">
      <div class="welcomeWord">
        单位信息
      </div>
      <div class="welcomeTip">
        添加更多在校经历
      </div>
    </div>
    <div class="userDataForm">
      <van-form label-width="300px">
        <van-field v-model="workData.industry" is-link readonly label="行业领域" placeholder="请选择行业领域"
          @click="checkIndustryShow = true" />
        <van-popup v-model="checkIndustryShow" round position="bottom">
          <van-cascader v-model="industryValue" title="请选择行业领域" :options="industryOptions" :field-names="fieldNames"
            active-color="#1989fa" @close="checkIndustryShow = false" @finish="onIndustryShowFinish" />
        </van-popup>
        <div class="driverLine"></div>

        <van-field v-model="workData.danwei" label="单位" placeholder="请输入工作单位" required />
        <div class="driverLine"></div>

        <van-field v-model="workData.zhiwu" label="职务（选填）" placeholder="请输入职务" />
        <div class="driverLine"></div>

        <van-field v-model="workData.zhicheng" label="职称（选填）" placeholder="请输入职称" />
        <div class="driverLine"></div>

        <van-field readonly clickable :value="dateString" label="工作年限（选填）" placeholder="开始时间 -- 结束时间"
          @click="dateShow = true">
          <template slot="right-icon">
            <van-icon name="arrow" />
          </template>
        </van-field>
        <div class="driverLine"></div>
        <!-- 在校时间弹窗 -->
        <van-popup v-model="dateShow" position="bottom" round>
          <van-picker show-toolbar title="在校时间" :columns="columns" @cancel="dateShow = false" @confirm="selectDate">
          </van-picker>
        </van-popup>
      </van-form>
    </div>
    <div class="nextIconDiv" @click="submit">
      <img src="../../assets/image/btn_xiayibu_nor.png" alt="" class='nextIcon'>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkIndustryShow: false,
      industryValue: '',
      fieldNames: {
        text: 'name',
        value: 'code',
        children: 'items',
      },
      industryOptions: [],
      workData: {
        industry: '',
        danwei: '',
        zhiwu: '',
        zhicheng: '',
        officeBegin: '',
        officeEnd: '',
        userId: window.localStorage.getItem("user_id"),
        //userId: 141,
        url: window.localStorage.getItem("imgUrl"),
      },
      dateString: '',
      dateShow: false,
      columns: [
        // 第一列
        {
          values: [],
          defaultIndex: 2,
        },
        // 第二列
        {
          values: [],
          defaultIndex: 1,
        },
      ],
    };
  },
  created() {
    this.getIndustry1List()
    let date = new Date();
    let year = date.getFullYear(); //获取当前年份
    for (let i = year; i > 1909; i--) {
      this.columns[0].values.push(i);
    }
    this.columns[1].values.push('至今')
    for (let i = year + 4; i > 1909; i--) {
      this.columns[1].values.push(i);
    }
  },
  methods: {
    // 行业领域1级分类
    async getIndustry1List() {
      const res = await this.$http.get("/amresources/getIndustryLevelList")
      if (res.data.IndustryLevelList) {
        const arr = []
        res.data.IndustryLevelList.forEach((item, index) => {
          arr.push({
            name: item,
            code: item,
            items: this.getIndustry2List(item)
          })
        })
        this.industryOptions = arr
      }
    },
    // 行业领域2级分类
    getIndustry2List(industry) {
      const arr = []
      this.$http.get("/amresources/getIndustryList", {
        params: { industryLevel: industry }
      }).then(res => {
        if (res.data.IndustryList) {
          res.data.IndustryList.forEach(item => {
            arr.push({
              name: item,
              code: item
            })
          })
        }
      }).catch(() => { })
      return arr
    },
    onIndustryShowFinish({ selectedOptions }) {
      this.checkIndustryShow = false
      this.workData.industry = selectedOptions.map((option) => option.name).join('/')
    },
    async submit() {
      let userData = JSON.parse(window.sessionStorage.getItem('userData'))
      let atSchoolData = JSON.parse(window.sessionStorage.getItem('atSchoolData'))
      if (this.workData.industry === '') {
        this.$message("请选择行业领域")
      } else if (this.workData.danwei === '') {
        this.$message("请填写单位信息")
      } else {
        let xueJiEntity = {};
        xueJiEntity = Object.assign(atSchoolData, userData, this.workData);
        const idcard = (xueJiEntity.idcard || '').trim();
        let res;
        try {
          res = await this.$http({
            url: "/xjcard/insertXJCard",
            method: "POST",
            // headers: { "content-type": "application/x-www-form-urlencoded" },
            data: xueJiEntity,
          })
        } catch (error) {
          const msg = (error && error.body && error.body.msg)
            || (error && error.response && error.response.data && error.response.data.message)
            || (error && error.message)
            || '提交失败';
          this.$message(msg);
          return;
        }
        
        // success自动比对 0失败 1成功  code 0失败 1已填写身份证 2未填写身份证
        if (res.data.code == 500) {
          this.$toast(res.data.message);
          return;
        }

        localStorage.setItem("real", res.data.data)
        if (res.data.code == 200 && res.data.data == 0) {
          this.$toast(res.data.message);
          this.$router.push({
            path: "/failAuthentication",
            query: {
              authentication: 0,
              authenticationReason: res.data.message,
            },
          });
        } else if (res.data.data == 1) {
          this.$router.push({
            path: "/idSucess",
            query: {
              idcard,
            },
          })
        } else {
          this.$message(res.data.message);
        }
      }
    },
    // // 身份验证
    async verification() {
      let ruleForm = this.$route.query.userData;
      ruleForm = this.$route.query.atSchoolData;
      ruleForm = this.workData;
      console.log("ruleForm", ruleForm);
      const res = await this.$http({
        url: "/xjcard/insertXJCard",
        method: "POST",
        data: ruleForm
      })
      if (res.data.data.success == 0) {
        this.$toast(res.data.data.msg);
        this.$router.push({
          path: "/failAuthentication",
          query: {
            authentication: 0,
            authenticationReason: res.data.data.msg,
          },
        });
      } else if (res.data.code == 0 && res.data.data.success == 1) {
        const userData = JSON.parse(window.sessionStorage.getItem('userData') || '{}')
        this.$router.push({
          path: "/idSucess",
          query: {
            idcard: (userData.idcard || '').trim(),
          },
        });
      } else if (res.data.code == 1 && res.data.data.success == 1) {
        this.$toast(res.data.data.msg);
        this.$router.push(`/index`);
      }
      console.log(res);
    },
    selectDate(value) {
      this.workData.officeBegin = value[0]
      this.workData.officeEnd = value[1]
      this.dateString = value[0] + '-' + value[1]
      this.dateShow = false;
    }
  }
}
</script>

<style lang="less" scoped>
.userData {
  min-height: 100vh;
  background-color: #FFFFFF;

  .welcomeDiv {
    padding: 30px 5% 10px 5%;

    .welcomeWord {
      font-size: 2rem;
      font-weight: 400;
      color: #333333;
    }

    .welcomeTip {
      margin-top: 10px;
      font-weight: 400;
      color: #333333;
    }
  }

  .userDataForm {
    width: 90%;
    margin: 0 5%;

    /deep/ .van-cell__right-icon {
      display: none;
    }
  }

  .nextIconDiv {
    margin: 0 auto;
    padding: 20px 0;
    width: 20vw;
    height: 20vw;

    .nextIcon {
      width: 100%;
      height: 100%;
    }
  }
}

.driverLine {
  width: 100%;
  height: 1px;
  background: #AAAAAA;
}

.van-cell {
  margin-top: 30px !important;
  display: block !important;
  padding: 0 !important;
  font-size: 1.2rem !important;
}

.van-cell__title,
.labelName {
  font-weight: 400;
  font-size: 1.2rem;
  color: #333333;
}

.van-cell__value {
  font-size: 1.1rem;
  margin: 15px 1% 5px 1%;
  width: 98%;
}
</style>



// WEBPACK FOOTER //
// src/components/register/WorkData.vue